import React, { memo } from 'react';
import Section from '../../../../components/outline/Section';
import TableTransfer from '../../../../components/input/TableTransfer';
import { BRAND_UPLOAD_TEMPLATE_XLSX_URL } from '../../../../constants/service/common/staticFileUrlConstants';
import { columns } from './columns';
import Button from '../../../../components/Button';
import Anchor from '../../../../components/link/Anchor';
import ExcelUploadForm from '../../../../components/form/ExcelUploadForm';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/coupon/models';
import './CouponBrandLinkInfo.scss';

const CouponBrandLinkInfo = (props) => {
  const {
    couponBrandLinkInfo,
    getCouponBrandItemList,
    getCouponBrandItemListExcelDownload,
    getSelectedCouponBrandItemListExcelDownload,
    checkValidCouponBrandItemListExcelUpload,
    selectCouponBrandItemList,
    toggleModal,
    minimumPurchasePrice,
    discountAmount,
    discountType,
    maxDiscountPrice,
    exclude24k,
  } = props;
  const { itemList, selectedItemList } = couponBrandLinkInfo;

  return (
    <div className="coupon-brand-link-info">
      <Section className="coupon-check-brand-item tap-section" title="적용 브랜드 선택">
        <div className="notice">
          브랜드별 적용 가능 상품수는 상품별 할인정책에 따라 변동될 수 있습니다.
          <br />
          선택 된 브랜드는 APP/WEB에서 브랜드 티어 오름차순(티어 내 오름차순)으로 노출 됩니다.
        </div>

        <TableTransfer
          dataSource={itemList.list}
          operations={['연결', '해제']}
          leftTitle="브랜드 리스트"
          rightTitle="선택된 브랜드 리스트"
          leftTableProps={{
            columns: (utils) =>
              columns({
                ...utils,
                isFilter: true,
                toggleModal,
                minimumPurchasePrice,
                discountAmount,
                discountType,
                maxDiscountPrice,
                exclude24k,
              }),
            headInfo: (
              <div className="coupon-check-brand-item-head">
                <div className="excel-button-list">
                  <Button isRadius color="light" text="엑셀 다운로드" onClick={getCouponBrandItemListExcelDownload} />
                </div>
              </div>
            ),
            rowClassName: (record) => (record.uncheckable ? 'uncheckable' : null),
            getList: getCouponBrandItemList,
            pagination: itemList.pagination,
            filterOption: itemList.filterOption,
            initialOption: {
              filterOption: COUPON_BRAND_ITEM_LIST_FILTER_OPTION_MODEL,
              pagination: _LIST_PAGINATION_MODEL,
            },
          }}
          rightTableProps={{
            columns: (utils) =>
              columns({
                ...utils,
                toggleModal,
                minimumPurchasePrice,
                discountAmount,
                discountType,
                maxDiscountPrice,
                exclude24k,
              }),
            headInfo: (
              <div className="selected-coupon-check-brand-item-head">
                <div className="selected-coupon-check-brand-item-count">
                  선택된 브랜드 개수 <span>{selectedItemList.list.length}</span>
                </div>

                <div className="excel-button-list">
                  <Anchor
                    text="브랜드 업로드 템플릿"
                    isUnderLine
                    color="primary"
                    href={BRAND_UPLOAD_TEMPLATE_XLSX_URL}
                    target="_blank"
                  />

                  <ExcelUploadForm
                    onChange={(file) => checkValidCouponBrandItemListExcelUpload(file)}
                    btnText="브랜드 엑셀 업로드"
                  />

                  <Button
                    isRadius
                    color="light"
                    text="엑셀 다운로드"
                    onClick={getSelectedCouponBrandItemListExcelDownload}
                  />
                </div>
              </div>
            ),
            list: selectedItemList.list,
          }}
          onChange={(action, moveIdList) => selectCouponBrandItemList(action, moveIdList)}
        />
      </Section>
    </div>
  );
};

export default memo(CouponBrandLinkInfo);
